import { EyeOutlined } from '@ant-design/icons';
// ProTable
export const PRO_TABLE_CONFIG = (
    x: number = 1000,
    scrollable: boolean = true,
    defaultPageSize: number = 30,
) => {
    const common = {
        pagination: {
            defaultPageSize,
            pageSizeOptions: [5, 10, 20, 30, 50, 100],
            showSizeChanger: true,
        },
        search: {
            filterType: 'query',
            defaultCollapsed: false,
        },
    };

    if (scrollable) {
        const scroll = {
            scroll: {
                scrollToFirstRowOnChange: true,
                x,
                y: 'auto',
            },
        };
        return { ...common, ...scroll };
    } else {
        return common;
    }
};

// ProForm
export const PRO_FORM_CONFIG = {
    layout: 'horizontal',
    grid: true,
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
    labelWrap: true,
    scrollToFirstError: true,
};

// ModalForm
export const MODAL_FORM_CONFIG = {
    layout: 'horizontal',
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
    modalProps: {
        destroyOnClose: true,
        maskClosable: false,
        lockScroll: true,
    },
    labelWrap: true,
};

// PageContainer 内容高度
export const FULL_PAGE_CONTAINER_CONTENT = {
    height: 'calc(100vh - 56px - 64px - 16px + 32px)',
};

// Drawer
export const DRAWER_CONFIG = {
    width: 600,
    destroyOnClose: true,
    maskClosable: false,
};

// FormGroup
export const FORM_GROUP_CONFIG = {
    style: {
        border: '1px dashed lightGray',
        padding: '10px',
        margin: '10px 0',
    },
};

export const formItemLayout = {
    layout: 'horizontal',
    grid: true,
    labelCol: { span: 4 },
    wrapperCol: { span: 16 },
    labelWrap: true,
    scrollToFirstError: true,
};

export const IMAGE_CONFIG = {
    mask: <EyeOutlined />,
};
